import React, { useState } from 'react';
import FormModalMultiStep from 'v2/common/FormModalMultiStep/FormModalMultiStep';
import { BulkImportType } from './formSteps/FileSelection/hooks';
import { useBulkImportStepFlow } from './hooks';

interface BulkImportModalProps {
  defaultBulkImportType: BulkImportType;
  onClose: () => void;
}

const BulkImportModal = ({
  onClose,
  defaultBulkImportType,
}: BulkImportModalProps) => {
  const [bulkImportType, setBulkImportType] = useState(defaultBulkImportType);
  const {
    formContext,
    isLoading,
    isSuccess,
    stepErrors,
    onSubmit,
    steps,
    show,
  } = useBulkImportStepFlow({
    bulkImportType,
    onBulkImportTypeChange: (bulkImportType) =>
      setBulkImportType(bulkImportType ?? defaultBulkImportType),
  });

  return (
    // Added any as the form type since we are swapping between two
    // different forms which causes types errors.
    <FormModalMultiStep<any>
      show={show}
      title="Bulk Import"
      onClose={onClose}
      onSubmit={onSubmit}
      isLoading={isLoading}
      formContext={formContext}
      isSuccess={isSuccess}
      steps={steps}
      errors={stepErrors}
      stepsRenderKey={bulkImportType}
    />
  );
};

export default BulkImportModal;
